import { holderName } from "@panel/shared/contract/misc/helpers";

/**
 * The brand's uploaded contract template, from the overview's `template`.
 * Null while nothing has been uploaded.
 * @param raw
 */
export const normalizeTemplate = (raw) => {
    if (!raw?.file_url) return null;

    const meta = raw.file_meta || {};

    return {
        id       : raw._id || null,
        version  : raw.version ?? null,
        name     : meta.original_name || meta.name || "contract.pdf",
        size     : meta.size ?? 0,
        createdAt: raw.createdAt || raw.created_at || null,
        createdBy: holderName(raw.created_by)
    };
};
